import { render, staticRenderFns } from "./IresDeviceOverviewItem.vue?vue&type=template&id=0f35e1ea&scoped=true&"
import script from "./IresDeviceOverviewItem.vue?vue&type=script&lang=ts&"
export * from "./IresDeviceOverviewItem.vue?vue&type=script&lang=ts&"
import style0 from "./IresDeviceOverviewItem.vue?vue&type=style&index=0&id=0f35e1ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f35e1ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCheckbox,VCol,VDivider,VRow,VSpacer})
